import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import Modal from 'Components/UI/Modal';
import { Icon } from 'Components/UI';
import styles from './AvisoUsuarioUpgrade.module.scss';

import PlanoAvisoUsuarioUpgrade from 'Static/images/plano-aviso-convite-upgrade.png';

interface IAvisoUsuarioUpgrade {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  role?: number;
}

const AvisoUsuarioUpgrade: FC<IAvisoUsuarioUpgrade> = ({
  visible,
  onCancel,
  onConfirm,
  role
}) => {
  const { t } = useTranslation('sharedModals');

  return (
    <Modal
      footerButtons={false}
      visible={visible}
      width={'auto'}
      onCancel={onCancel}
    >
      <div className={styles['wrapper']}>
        <div className={styles['imageWrapper']}>
          <img src={PlanoAvisoUsuarioUpgrade}></img>
        </div>
        <div className={`${styles['contentWrapper']}`}>
          <div>
            <label className={styles['avisoLimiteObras']}>
              {role === 1
                ? t('upgradeUser.limitWarningPersonal')
                : t('upgradeUser.limitWarningCompany')}
            </label>
          </div>
          <h2>
            {role === 1
              ? t('upgradeUser.upgradeHeadingPersonal')
              : t('upgradeUser.upgradeHeadingCompany')}
          </h2>
          <h3>{t('upgradeUser.manageUsers')}</h3>

          <p>{t('upgradeUser.premiumProvides')}</p>
          <div className={styles['icons-wrapper']}>
            <div className={`${styles['icons-text-wrapper']} ${styles['icons-text-margin']}`}>
              <div>
                <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                <span>{t('upgradeUser.feature2d3d')}</span>
              </div>
              <div>
                <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                <span>{t('upgradeUser.featureNomenclature')}</span>
              </div>
            </div>
            <div className={styles['icons-text-wrapper']}>
              <div>
                <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                <span>{t('upgradeUser.featureUserManagement')}</span>
              </div>
              <div>
                <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                <span>{t('upgradeUser.featurePlotting')}</span>
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>&nbsp;</div>
          </div>

          <div className={styles['button-wrapper']}>
            <Button className={styles['button-cancel']} type='link' width={190} height={48} onClick={onCancel}>
              {t('upgradeUser.maybeLater')}
            </Button>

            <Button className={styles['button-confirm']} type='primary' ispremium="true" width={287} height={48} onClick={onConfirm}>
              <Icon icon="crown" className={styles['icon']} size="xxs" color="cinzaEscuro" />
              {role === 1
                ? t('upgradeUser.acquirePremiumPersonal')
                : t('upgradeUser.acquirePremiumCompany')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AvisoUsuarioUpgrade;
